import { ImageTextBlockProps } from '../../types'

export interface ImageTextLayout {
  // Image above the text, at the full column width
  stacked: boolean
  // Otherwise: the most of the row the image may take, in percent
  imageShare: number
  // Row direction: the image comes first on the left
  direction: 'row' | 'row-reverse'
}

/**
 * Where the image goes, following legacy's imagetext: on a wide page the
 * image sits beside the text (about two fifths of the row, or at most a
 * quarter when small); on a narrow one a standard image goes above the text,
 * while a small one stays beside it at up to a third.
 */
export const imageTextLayout = (
  { side, imageSize }: Pick<ImageTextBlockProps, 'side' | 'imageSize'>,
  isWide: boolean
): ImageTextLayout => {
  const small = imageSize === 'small'
  return {
    stacked: !isWide && !small,
    imageShare: small ? (isWide ? 25 : 33) : 38,
    direction: side === 'right' ? 'row-reverse' : 'row'
  }
}
